import settings from "@/core/settings"
import logger from "@/core/logger"
import bus from "@/core/api/bus"
import visit from "@/core/visit"
import processBrowserQueue from "@/core/browserQueue"
import { WebsiteOrder } from "@/types"
import { fetch, FetchError, isUnreachable } from "@/core/fetch"

export interface Violation {
  key: string
  message_key: string
}

export interface ErrorResponse {
  errors: Violation[]
}

export interface OrderError {
  payload: WebsiteOrder
  response: ErrorResponse
}

export default async function track(order: WebsiteOrder) {
  try {
    const params = new URLSearchParams({
      merchant: settings.account!,
      c: visit.getCustomerId()!
    })
    await fetch(`${settings.server}/order/track?${params}`, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain"
      },
      body: JSON.stringify(order)
    })
  } catch (err) {
    if (err instanceof FetchError && err.response?.status === 400) {
      const responseData = (await err.response!.json()) as ErrorResponse
      if (responseData.errors) {
        const rows = [
          "The current order tagged is invalid. These are the validation errors that must be rectified.",
          "For more information on how to tag the orders, see",
          "https://docs.nosto.com/techdocs/implementing-nosto/implement-on-your-website/manual-implementation/order-tagging"
        ]
        responseData.errors.forEach((violation: Violation) => {
          const { key, message_key } = violation
          rows.push(`• ${key}: ${message_key}`)
        })
        const message = rows.join("\n")
        logger.info(message)
        bus.emit("ordererror", { payload: order, response: responseData })
        bus.emit("servererror", [message])
        return
      }
    }
    if (isUnreachable(err)) {
      logger.warn("Failed to track order", err)
    } else {
      logger.error("Failed to track order", err)
    }
  }
  await processBrowserQueue()
}
